import type {
  ComponentType,
  ElementType,
  MouseEvent,
  ReactNode,
  RefObject,
} from 'react';
import type {
  BackgroundProps,
  BorderProps,
  ColorProps,
  FlexboxProps,
  GridProps,
  LayoutProps,
  PositionProps,
  ResponsiveValue,
  ShadowProps,
  SpaceProps,
  TypographyProps,
} from 'styled-system';

import { BaseBox } from './BaseBox';

type AllStyledSystemProps = FlexboxProps &
  SpaceProps &
  TypographyProps &
  BorderProps &
  PositionProps &
  ColorProps &
  LayoutProps &
  ShadowProps &
  GridProps &
  BackgroundProps;

type AdditionalStyleProps = {
  transform: ResponsiveValue<string>;
  whiteSpace: ResponsiveValue<string>;
  wordBreak: ResponsiveValue<string>;
  transition: ResponsiveValue<string>;
  willChange: ResponsiveValue<string>;
  pointerEvents: ResponsiveValue<string>;
  cursor?: string;
  textTransform?: string;
};

type BoxProps<TComponentProps> = AllStyledSystemProps &
  Partial<AdditionalStyleProps> & {
    ref?: RefObject<HTMLElement | null>;
    id?: string;
    className?: string | null;
    children?: ReactNode;
    component?: ComponentType<TComponentProps> | ElementType;
    onClick?: (event: MouseEvent<HTMLElement>) => void;
    qaId?: string;
  } & TComponentProps;

function BoxWithForwardedRef<TComponentProps>({
  ref,
  qaId,
  ...props
}: BoxProps<TComponentProps>) {
  return (
    <BaseBox
      ref={ref}
      qaId={qaId}
      // oxlint-disable-next-line typescript/no-explicit-any
      {...(props as any)} // eslint-disable-line react/jsx-props-no-spreading
    />
  );
}

/**
 * @deprecated please do not add new code using <Box> - this is a catch-all component that makes maintenance more difficult. Please use `styled.div` whenever possible
 */
export function Box<TComponentProps>(props: BoxProps<TComponentProps>) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <BoxWithForwardedRef {...props} />;
}
